import * as React from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridRowModel,
} from "@mui/x-data-grid";
import {
  Button,
  IconButton,
  Link,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { GRID_ZH_LOCALE_TEXT } from "../../locale/GridLocale_zh";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { store } from "../../redux/store";
import * as requestAction from "../../redux/action/requestAction";
import {
  applyRdpChannel,
  authSync,
  getMyRdpChannels,
  sendZhumiLinkToMail,
  updateTag,
} from "../../lib/api";
import HtmlTooltip from "../../component/HtmlTooltip";
let navigate: NavigateFunction;
const columns: GridColDef[] = [
  {
    field: "tag",
    headerName: "标签",
    headerAlign: "center",
    align: "left",
    description: "用于标记绑定的电脑，方便区分自己的多台电脑",
    width: 240,
    editable: true,
    renderCell: (params: GridRenderCellParams) => {
      let { row } = params;
      return (
        <Box>
          {!row.tag && (
            <Typography
              color={"red"}
              variant="body2"
              display="block"
              gutterBottom
            >
              双击设置
            </Typography>
          )}
          {row.tag && (
            <Typography
              color={"green"}
              variant="body2"
              display="block"
              gutterBottom
            >
              {row.tag}
            </Typography>
          )}
        </Box>
      );
    },
  },
  {
    field: "clientId",
    headerName: "客户端id",
    description: "客户端id，一般排查问题时才需要",
    headerAlign: "center",
    align: "center",
    type: "string",
    width: 200,
    editable: false,
    renderCell: (params: GridRenderCellParams) => {
      let { row } = params;
      const clientId = `${row.clientId}`;
      return (
        <Box>
          <Typography variant="body2" display="block" gutterBottom>
            {clientId.substring(0, 8) + "..."}
            <Tooltip title="复制客户端ID">
              <IconButton
                size="small"
                onClick={() => {
                  handleCopy(clientId, `${row.tag}的客户端id已复制`);
                }}
              >
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Typography>
        </Box>
      );
    },
  },
  {
    field: "entryPoint",
    headerName: "访问地址",
    description: "打开远程桌面客户端后，复制并输入该地址，即可访问远程桌面",
    headerAlign: "center",
    align: "center",
    type: "string",
    width: 200,
    editable: false,
    renderCell: (params: GridRenderCellParams) => {
      let { row } = params;
      const rdpAddress = `${row.gatewayServer}:${row.gatewayPort}`;
      return (
        <Box>
          <Typography variant="body2" display="block" gutterBottom>
            {rdpAddress}
            <Tooltip title="复制该地址用于远程桌面访问">
              <IconButton
                size="small"
                onClick={() => {
                  handleCopy(
                    rdpAddress,
                    `${row.tag}的访问地址已复制，使用mstsc开启远程桌面`
                  );
                }}
              >
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Typography>
        </Box>
      );
    },
  },
  {
    field: "mapping",
    headerName: "网络映射",
    headerAlign: "center",
    align: "center",
    width: 280,
    renderCell: (params: GridRenderCellParams) => {
      let { row } = params;
      const mapping = `${row.gatewayServer}:${row.gatewayPort}->localhost:3389`;
      return (
        <Typography
          color={"green"}
          variant="body2"
          display="block"
          gutterBottom
        >
          {mapping}
        </Typography>
      );
    },
  },
  {
    field: "expireDate",
    headerName: "通道有效期",
    headerAlign: "center",
    align: "center",
    type: "string",
    width: 100,
    editable: false,
  },
  {
    field: "status",
    headerName: "状态",
    headerAlign: "center",
    align: "center",
    type: "string",
    width: 80,
    editable: false,
    renderCell: (params: GridRenderCellParams) => {
      let { row } = params;
      const color = row.status === "生效中" ? "green" : "red";
      return (
        <Typography color={color} variant="body2" display="block" gutterBottom>
          {row.status}
        </Typography>
      );
    },
  },

  {
    field: "opt",
    headerName: "操作",
    align: "center",
    headerAlign: "center",
    width: 320,
    renderCell: (params: GridRenderCellParams) => {
      const { row } = params;
      return (
        <Box>
          {/* <Tooltip title="延长使用期限，最小单位是1个月">
            <Button variant="text" onClick={()=>{handleRenew(row)}}>续期</Button>
          </Tooltip> */}

          <HtmlTooltip
            title={
              <React.Fragment>
                <Typography variant="subtitle2">
                  生成配置文件：link.yml
                </Typography>
                <Typography variant="subtitle2">下载并解压客户端</Typography>
                <Typography variant="subtitle2">
                  将link.yml放入客户端文件夹
                </Typography>
                <Typography variant="subtitle2">
                  或者替换已有的配置文件：link.yml
                </Typography>
                <Typography variant="subtitle2">
                  具体操作见：使用帮助
                </Typography>
              </React.Fragment>
            }
          >
            <Link
              style={{ textDecoration: "none" }}
              href={`${window.serverUrl}/rdp/config/generate/${row.clientId}`}
            >
              生成配置文件
            </Link>
          </HtmlTooltip>

          {/* <Tooltip title="由于运行客户端后，您的电脑暴露在公网。设置IP白名单可以有效保障您的电脑安全。">
            <Button variant="text" onClick={()=>{handleWhitelist(row)}}>设置白名单</Button>
          </Tooltip> */}

          <Tooltip title="续期后如未及时生效，仍无法访问，可点击手动同步">
            <Button
              variant="text"
              onClick={() => {
                handleAuthSync(row);
              }}
            >
              同步过期状态
            </Button>
          </Tooltip>
        </Box>
      );
    },
  },
];

function handleRenew(row: any) {
  if (!row.tag) {
    store.dispatch(
      requestAction.notify({
        type: "warning",
        text: "请先给当前通道设置一个标签后再进行续期操作",
      })
    );
    return;
  }
  navigate("/console/desktop/renew", { state: row });
}
/**
 * 白名单设置
 * @param row
 */
function handleWhitelist(row: any) {}
/**
 * 手动同步授权信息到服务器
 * @param row
 */
async function handleAuthSync(row: any) {
  if (!row.tag) {
    store.dispatch(
      requestAction.notify({
        type: "warning",
        text: "请先给当前通道设置一个标签后再进行续期操作",
      })
    );
    return;
  }

  const data = await authSync(row.id);
  if (data.success) {
    store.dispatch(requestAction.info(data.status.describe));
  } else {
    store.dispatch(requestAction.warning(data.status.describe));
  }
}

/**
 * 写入剪切板（写操作自动获取权限，读取剪切板需要用户授权）
 * @param content
 */
function handleCopy(content: string, remark: string) {
  if (remark.indexOf("undefined") !== -1) {
    store.dispatch(
      requestAction.notify({
        type: "warning",
        text: "请先给当前通道设置一个标签后再进行复制",
      })
    );
    return;
  }
  navigator.clipboard.writeText(content);
  store.dispatch(requestAction.notify({ text: remark }));
}

export default function RemoteDesktop() {
  navigate = useNavigate();
  function RDPToolbar() {
    return (
      <Toolbar>
        <Stack direction="row" spacing={2}>
          <Tooltip title="最多申请5个远程桌面通道，通道由系统自动分配。申请成功后，建议尽快设置一个标签，方便区分。另外：电脑密码请设置复杂一些，因为运行客户端后，您的电脑将暴露在公网上。">
            <Button
              variant="outlined"
              onClick={() => {
                createRdpChannel();
              }}
            >
              申请远程桌面转发通道
            </Button>
          </Tooltip>
          <Tooltip title="手把手教你如何使用远程桌面通道来访问您的windows电脑，以及一些常见问题的处理办法">
            <Button
              variant="outlined"
              onClick={() => {
                navigate("/");
              }}
            >
              使用帮助
            </Button>
          </Tooltip>
          <Tooltip title="点击发送到您的登录邮箱">
            <Button
              variant="contained"
              color="info"
              sx={{ textTransform: "none" }}
              onClick={() => {
                handelSendZhumiLinkToMail("zhumi.link-windows-amd64.zip");
              }}
            >
              客户端-Windows
            </Button>
          </Tooltip>
          <Tooltip title="点击发送到您的登录邮箱">
            <Button
              variant="contained"
              color="success"
              sx={{ textTransform: "none" }}
              onClick={() => {
                handelSendZhumiLinkToMail("zhumi.link-macos-arm64.zip");
              }}
            >
              客户端-Macos
            </Button>
          </Tooltip>
          <Tooltip title="点击发送到您的登录邮箱">
            <Button
              color="secondary"
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={() => {
                handelSendZhumiLinkToMail("zhumi.link-linux-amd64.zip");
              }}
            >
              客户端-Linux
            </Button>
          </Tooltip>
        </Stack>
      </Toolbar>
    );
  }

  async function handelSendZhumiLinkToMail(packageName: string) {
    const resp = await sendZhumiLinkToMail(packageName);
    if (resp.success) {
      store.dispatch(
        requestAction.notify({
          text: "邮件已发送到登录邮箱，请查收",
        })
      );
    }
  }
  async function createRdpChannel() {
    const resp = await applyRdpChannel();
    if (resp.success) {
      store.dispatch(
        requestAction.notify({
          text: "申请成功。您可以查看使用帮助，以尽快使用上远程桌面通道",
        })
      );
      loadRows();
    } else {
      store.dispatch(
        requestAction.notify({ type: "error", text: resp.status.describe })
      );
    }
  }
  const [rows, setRows] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    loadRows();
  }, []);
  function loadRows() {
    getMyRdpChannels().then((res) => {
      if (res.response.list) {
        setRows(res.response.list);
        setLoading(false);
      }
    });
  }
  return (
    <Box sx={{ height: window.innerHeight - 64, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        showCellRightBorder
        loading={loading}
        showColumnRightBorder
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50, 100]}
        checkboxSelection={false}
        localeText={GRID_ZH_LOCALE_TEXT}
        disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
        processRowUpdate={async (
          newRow: GridRowModel,
          oldRow: GridRowModel
        ) => {
          if (newRow.tag === oldRow.tag) {
            return oldRow;
          }
          if (newRow.tag?.length < 3) {
            store.dispatch(
              requestAction.notify({ type: "warning", text: "标签值过于简短" })
            );
            return oldRow;
          }
          updateTag(newRow.id, newRow.tag);
          store.dispatch(
            requestAction.notify({ type: "default", text: "标签设置成功" })
          );
          return newRow;
        }}
        onProcessRowUpdateError={async (err: Error) => {}}
        components={{
          Toolbar: RDPToolbar,
        }}
      />
    </Box>
  );
}
